module.exports = __webpack_public_path__ + "static/media/creditladder.f2507f4d.png";